module.exports = __webpack_public_path__ + "static/sai_certificate-8ecf7a4c40e01ebae7e5265409d22def.jpg";